module.exports = __webpack_public_path__ + "static/media/ignition-off.4b7e46bd.svg";